import { rankingList } from '@/mocks/buzz';

export default function Ranking() {
  return (
    <section id="ranking" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto grid gap-8 lg:grid-cols-[1fr_1.3fr] lg:items-center">
        <div className="lg:pr-8">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-coral-50 px-3 py-1 text-xs font-bold text-coral-600">
            <i className="ri-fire-line" /> 热度实时排行
          </span>
          <h2 className="mt-4 font-display text-3xl leading-tight md:text-4xl">
            今天大家都在
            <br />
            <span className="text-coral-500">围观哪一口瓜？</span>
          </h2>
          <p className="mt-4 text-sm leading-6 text-ink-soft md:text-base">
            按讨论热度实时聚合的当日 Top 榜单，热度值每 5 分钟更新一次，一眼看清全网风向。
          </p>
          <div className="mt-6 grid grid-cols-2 gap-4">
            <div className="rounded-2xl border border-paper bg-card p-4">
              <p className="font-display text-3xl text-leaf-500">3</p>
              <p className="mt-1 text-xs text-ink-soft">分钟补完全部重点</p>
            </div>
            <div className="rounded-2xl border border-paper bg-card p-4">
              <p className="font-display text-3xl text-coral-500">Top10</p>
              <p className="mt-1 text-xs text-ink-soft">全天实时刷新</p>
            </div>
          </div>
        </div>

        <ol className="space-y-3">
          {rankingList.map((r) => (
            <li key={r.rank}>
              <div className="flex items-center gap-4 rounded-2xl border border-paper bg-card px-4 py-3.5 transition-colors hover:border-coral-200">
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl font-display text-lg ${
                    r.rank <= 3 ? 'bg-coral-500 text-white' : 'bg-paper text-ink-soft'
                  }`}
                >
                  {r.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-bold text-ink md:text-base">{r.title}</h3>
                  <p className="mt-0.5 text-xs text-ink-muted">
                    {r.category} · 热度 {r.heat}
                  </p>
                </div>
                <span
                  className={`hidden items-center gap-1 whitespace-nowrap text-xs font-bold sm:inline-flex ${
                    r.trend === 'up' ? 'text-coral-500' : 'text-ink-muted'
                  }`}
                >
                  <i className={r.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} />
                  {r.trend === 'up' ? '上升' : '回落'}
                </span>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}